import type { RouteRecordRaw } from "vue-router";

const routes = [
    {
        path: "/",
        component: () => import("@/layouts/FullScreenLayout.vue"),
        children: [
            {
                name: "landing",
                path: "/",
                meta: {
                    auth: "noAuthOnly",
                    requiredFeatures: ["landingPage", "authentication"]
                },
                component: () => import("@/pages/LandingPage.vue")
            },
            {
                name: "details",
                path: "details/:groupId?/:contentId",
                component: () => import("@/pages/DetailsPage.vue")
            }
        ]
    },
    {
        path: "/",
        component: () => import("@/layouts/HeaderOnlyLayout.vue"),
        children: [
            {
                name: "signup",
                path: "signup",
                meta: {
                    requiredFeatures: ["authentication", "subscriptions"],
                    auth: "noAuthOnly"
                },
                component: () => import("@/pages/SignupPage.vue"),
                props(to) {
                    return { redirect: to.query.redirect };
                }
            },
            {
                name: "login",
                path: "login",
                component: () => import("@/pages/LoginPage.vue"),
                meta: {
                    requiredFeatures: ["authentication"],
                    auth: "noAuthOnly"
                },
                props(to) {
                    return { redirect: to.query.redirect };
                }
            }
        ]
    },
    {
        path: "/",
        component: () => import("@/layouts/MainLayout.vue"),
        children: [
            {
                name: "browse",
                path: "browse/:id?",
                component: () => import("@/pages/BrowsePage.vue")
            },
            {
                name: "search",
                path: "search",
                component: () => import("@/pages/SearchPage.vue")
            },
            {
                name: "watch",
                path: "watch/:id",
                component: () => import("@/pages/WatchPage.vue")
            },
            {
                name: "liveCountdown",
                path: "live-countdown/:id",
                component: () => import("@/pages/LiveCountdownPage.vue")
            },
            {
                name: "subscribe",
                path: "subscribe",
                component: () => import("@/pages/SubscribePage.vue"),
                meta: {
                    requiredFeatures: ["authentication", "subscriptions"],
                    auth: "authOnly"
                },
                props(to) {
                    return { redirect: to.query.redirect };
                }
            }
            /*
            TODO add reset password route
            {
                name: 'resetPassword',
                path: 'user/:userId/change-password/:token',
                component: () => import('@/pages/ResetPasswordPage.vue'),
                meta: { auth: "noAuthOnly", requiredFeatures: ["authentication"] },
            },
            */
        ]
    },

    // Always leave this as last one,
    // but you can also remove it
    {
        name: "NotFound",
        path: "/:catchAll(.*)*",
        component: () => import("@/pages/ErrorNotFound.vue")
    }
] satisfies RouteRecordRaw[];

export default routes;
